module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-0-078e4473808d46d68a63ffcda4365807.jpg";